import { RootState } from "redux/rootReducer";

export const selectIsGettingHolidayList = (state: RootState) =>
  state.holidayList.loading;
export const selectAddRequestErrorMessage = (state: RootState) =>
  state.holidayList.error;
export const holidayListDataResponse = (state: RootState) =>
  state.holidayList.holidayListResponse;
